import { Router } from '@angular/router';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
  UserAuth,
  CollapseSectionService,
  PagesEventService,
} from 'src/app/common';
import { User } from 'src/app/common/user-auth';
import { LayoutService } from '../services/layout.service';
import { Url } from 'src/app/common/index';
import { InboxeViewModel } from '../../pages/default/time-management/models/inboxe.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: '../views/sidebar.component.html',
  styleUrls: ['../styles/style.css'],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  userAuth: User = UserAuth.get();
  inboxeViewModel: InboxeViewModel = new InboxeViewModel();
  BORDER_THICKNESS = 2;

  permisions = {
    READ_PROJECT: this.userAuth.getAction('READ_PROJECT'),
    READ_MODULE: this.userAuth.getAction('READ_MODULE'),
    READ_EMPLOYEE_OVERVIEW: this.userAuth.getAction('READ_EMPLOYEE_OVERVIEW'),
    READ_FILIALE: this.userAuth.getAction('READ_FILIALE'),
    READ_ORGANIZATION_CHART: this.userAuth.getAction('READ_ORGANIZATION_CHART'),
    READ_CLIENT: this.userAuth.getAction('READ_CLIENT'),
    READ_PARTNER_OVERVIEW: this.userAuth.getAction('READ_PARTNER_OVERVIEW'),
    READ_RESOURCES_VEHICLES: this.userAuth.getAction('READ_RESOURCES_VEHICLES'),
    READ_RESOURCES_CONSTRUCTION_VEHICLES: this.userAuth.getAction(
      'READ_RESOURCES_CONSTRUCTION_VEHICLES'
    ),
    READ_RESOURCES_TRAILER_VEHICLES: this.userAuth.getAction(
      'READ_RESOURCES_TRAILER_VEHICLES'
    ),
    READ_RESOURCES_MEASURING_VEHICLES: this.userAuth.getAction(
      'READ_RESOURCES_MEASURING_VEHICLES'
    ),
    READ_RESOURCES_TOOLS: this.userAuth.getAction('READ_RESOURCES_TOOLS'),
    READ_RESOURCES_SPLICING_DEVICES: this.userAuth.getAction(
      'READ_RESOURCES_SPLICING_DEVICES'
    ),
    READ_RESOURCES_CONTAINER: this.userAuth.getAction(
      'READ_RESOURCES_CONTAINER'
    ),
    READ_FINANCE: this.userAuth.getAction('READ_FINANCE'),
    READ_COST_CENTER: this.userAuth.getAction('READ_COST_CENTER'),
    READ_SPECIFICATION: this.userAuth.getAction('READ_SPECIFICATION'),
    READ_EDIT_WEEKLY_REPORT:
      this.userAuth.getAction('READ_EDIT_WEEKLY_REPORT_OWN') ||
      this.userAuth.getAction('READ_EDIT_WEEKLY_REPORT_ALL_EMP')
        ? true
        : false,
    READ_EDIT_MONTHLY_REPORT:
      this.userAuth.getAction('READ_EDIT_MONTHLY_REPORT_ALL_EMP') ||
      this.userAuth.getAction('READ_EDIT_MONTHLY_REPORT_SUBORDINATE')
        ? true
        : false,
    READ_ANNUAL_CALENDAR: this.userAuth.getAction('READ_ANNUAL_CALENDAR'),
    READ_INBOX:
      this.userAuth.getAction('READ_OWN_INBOX') ||
      this.userAuth.getAction('READ_ALL_INBOX')
        ? true
        : false,
    PRINT_WEEKLY_REPORT_ALL_EMP: this.userAuth.getAction(
      'PRINT_WEEKLY_REPORT_ALL_EMP'
    ),
    PRINT_MONTHLY_REPORT: this.userAuth.getAction('PRINT_MONTHLY_REPORT_ALL'),
    READ_EMP_FUNCTION: this.userAuth.getAction('READ_EMP_FUNCTION'),
    READ_WRITE_PAYOUTS: this.userAuth.getAction('READ_WRITE_PAYOUTS'),
    READ_TICKET_MANAGEMENT: this.userAuth.getAction('READ_TICKET_MANAGEMENT'),
    READ_TICKET: this.userAuth.getAction('READ_TICKET'),
    READ_MONTHLY_OVERVIEW:
      this.userAuth.getAction('READ_MONTHLY_OVERVIEW_SUBORDINATE') ||
      this.userAuth.getAction('READ_MONTHLY_OVERVIEW_ALL')
        ? true
        : false,
    READ_EDIT_EVALUATION_HOURS: this.userAuth.getAction(
      'READ_EDIT_EVALUATION_HOURS'
    ),
    READ_HOLIDAY_PLAN: this.userAuth.getAction('READ_HOLIDAY_PLAN'),
    READ_REPORTING:
      this.userAuth.getAction('READ_OWN_PROJECT_REPORTING') ||
      this.userAuth.getAction('READ_ALL_PROJECT_REPORTING')
        ? true
        : false,
    READ_EDIT_HOLIDAY_PLAN:
      this.userAuth.getAction('READ_EDIT_HOLIDAY_PLAN') ||
      this.userAuth.getAction('READ_EDIT_HOLIDAY_PLAN_All'),
    READ_CALENDAR: this.userAuth.getAction('READ_CALENDAR'),
  };

  appVersion = Url.appVersion;
  url = Url;
  ticketsAssignedToMe = false;
  financeOrderNr = 0;

  constructor(
    public layoutService: LayoutService,
    public pagesEventService: PagesEventService,
    public collapseSectionService: CollapseSectionService
  ) {
    this.pagesEventService.changeInbox.subscribe((value) => {
      if (value === 'change-inbox') {
        this.getInboxes();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var Menutoggled = localStorage.getItem('menu-toggled');
      if (Menutoggled == '1') {
        document.querySelectorAll('.dropdown-toggle').forEach((element) => {
          element.setAttribute('data-toggle', 'datahide');
        });
      }
    }, 1000);
  }

  ngOnInit() {

    const collapseSectionService = this.collapseSectionService;

    // Add an event listener to the document for clicks on elements with the 'collapse-header' class
    document.addEventListener('click', function (e:any) {

      console.log(e.target);
      if (e.target.classList.contains('collapse-header')) {
        if (e.target.classList.contains('dont-collapse')) return;
    
        const parentElement = e.target.parentElement;
    
        // Toggle the 'open' class on the parent element
        parentElement.classList.toggle('open');
    
        // Check if the parent element has an 'id' attribute
        if (parentElement.id) {
          collapseSectionService.setSection(
            parentElement.id,
            parentElement.classList.contains('open') ? 1 : 0
          );
        }
      }
    });
    
    // Retrieve the 'menu-toggled' value from localStorage
    const menuToggled = localStorage.getItem('menu-toggled');
    
    // Add the 'toggled' class to #wrapper if 'menu-toggled' is '1'
    if (menuToggled === '1') {
      const wrapper = document.querySelector('#wrapper');
      wrapper.classList.add('toggled');
    }
    

    // this.layoutService.getVersion().subscribe((response) => {

    //     if (Url.appVersion != response.Version) {
    //         location.reload(true);
    //     }
    // });

    if(this.permisions.READ_FINANCE)
    {
      this.layoutService.getFinanceNewOrders().subscribe((response) => {
        if (response.Status == 200) {
          this.financeOrderNr = response.OrdersNr;
        }
      });
    }
   

    this.getInboxes();
    this.getAssignedToMeNew();

  }

  sideBarToggle() {
    const wrapper = document.querySelector('#wrapper');

    wrapper.classList.toggle('toggled');
    
    localStorage.setItem(
      'menu-toggled',
      wrapper.classList.contains('toggled') ? '1' : '0'
    );
    
  }
  getInboxes() {
    this.layoutService.getInboxes(this.userAuth.id).subscribe((response) => {
      if (response.Status == 200) {
        this.inboxeViewModel.inboxes = response.inboxes;
      }
    });
  }

  getAssignedToMeNew() {
    this.layoutService
      .getAssignedToMeNew({ id: this.userAuth.id })
      .subscribe((response) => {
        if (response.TicketsAssignedToMe?.count > 0) {
          this.ticketsAssignedToMe = true;
        }
      });
  }




}
